import { Plural, Trans } from "@lingui/react/macro";

import {
  BackgroundColor,
  SectionContainer,
  SectionTitle,
  SectionTitleHeading
} from "@silversea-ssc/ui-components-react";
import React, { PropsWithChildren } from "react";
import { arrayIsNotEmpty } from "src/utils/checks";
import { ShipDiningAreaFragment } from "types/graphql-types";

type Props = {
  shipName: string;
  diningAreas: ShipDiningAreaFragment[];
  backgroundColor: BackgroundColor;
};

const ShipDiningAreas: React.FC<PropsWithChildren<Props>> = ({
  children,
  diningAreas,
  shipName,
  backgroundColor
}) => {
  if (!arrayIsNotEmpty(diningAreas)) return;

  return (
    <div className="hide-print" data-content-name="section_restaurants">
      <SectionContainer
        spacingTop="regular"
        spacingBottom="regular"
        backgroundColor={backgroundColor}
      >
        <SectionTitle variant="wide">
          <SectionTitleHeading>
            {shipName} <Trans>Dining Options</Trans>:<br />{" "}
            <Plural
              value={diningAreas?.length || 0}
              one="# Restaurant"
              other="# Restaurants"
            />
          </SectionTitleHeading>
        </SectionTitle>

        {children}
      </SectionContainer>
    </div>
  );
};

export default ShipDiningAreas;
